<div class="flex flex-wrap gap-x-4">
  <div class="w-full">
    <input 
      type="range" 
      min="0" 
      max="200" 
      value="100" 
      class="daisy-range daisy-range-primary" 
      #customerInput2
    />
  </div>
  <div class="w-full">
    <input type="number" id="sliderOutput1" class="daisy-input daisy-input-bordered w-full" />
  </div>
</div>
